module.exports = __webpack_public_path__ + "static/chenhao_li-5089db6890f31188435de826eedd6a91.jpg";